import { Klydo } from "../../../Types";
import { CalendarDay } from "./Calendar";
import DSAvatar from "../../system-design/DSAvatar";
import DSBox from "../../system-design/DSBox";
import DSChip from "../../system-design/DSChip";
import DSTooltip from "../../system-design/DSTooltip";
import DSTypography from "../../system-design/DSTypography";
import KlydoLoopUrl from "../../../components/klydoPreview/KlydoLoopUrl";
import { KLYDO_BLACK } from "../../../consts/colors";

interface ScheduledKlydoDayContentProps {
  day: CalendarDay;
  klydosByDate: { [key: string]: Klydo[] };
}

const ScheduledKlydoDayContent = ({
  day,
  klydosByDate,
}: ScheduledKlydoDayContentProps) => {
  const klydos = klydosByDate[day.date.toDateString()];

  if (!klydos || klydos.length === 0) return null;

  const isStacked = klydos.length >= 3;

  return (
    <DSBox sx={{ flex: 1 }}>
      <DSChip
        label={`${klydos.length} klydos`}
        size="small"
        variant="outlined"
        sx={{
          fontSize: "0.6rem",
          height: "auto",
          mb: 0.5,
          borderColor: KLYDO_BLACK,
          color: KLYDO_BLACK,
        }}
      />

      {klydos.length > 0 && (
        <DSBox
          sx={{
            mt: 1,
            display: "flex",
            flexWrap: isStacked ? "nowrap" : "wrap",
            gap: isStacked ? 0 : 0.5,
            alignItems: "center",
          }}
        >
          {klydos.slice(0, 3).map((klydo, index) => (
            <DSTooltip key={klydo.id} title={klydo.name}>
              <DSBox
                sx={{
                  width: 24,
                  height: 24,
                  overflow: "hidden",
                  borderRadius: "50%",
                  flexShrink: 0,
                  ...(isStacked && {
                    marginLeft: index === 0 ? 0 : "-10px",
                    border: "1px solid white",
                    zIndex: index,
                  }),
                  "&:hover": { transform: "scale(1.1)", zIndex: 10 },
                }}
              >
                {klydo.loopUrl ? (
                  <KlydoLoopUrl loopUrl={klydo.loopUrl} />
                ) : (
                  <DSAvatar sx={{ width: "100%", height: "100%" }}>
                    {klydo.name?.charAt(0) || "K"}
                  </DSAvatar>
                )}
              </DSBox>
            </DSTooltip>
          ))}
          {klydos.length > 3 && (
            <DSTypography
              variant="caption"
              sx={{
                fontSize: "0.6rem",
                color: "text.secondary",
                alignSelf: "center",
                ml: isStacked ? 0.5 : 0,
              }}
            >
              +{klydos.length - 3}
            </DSTypography>
          )}
        </DSBox>
      )}
    </DSBox>
  );
};

export default ScheduledKlydoDayContent;
